import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import { AngleOptions, COLOR_STYLE, OpacityOptions } from '@framework/workbench/drawer/common/config';
import {
    LINEAR_GRADIENT_ICON,
    RADIAL_GRADIENT_ICON,
    RECT_GRADIENT_ICON,
    SHAPE_GRADIENT_ICON,
} from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { angleStyle, buttonStyle, iconStyle, textStyle } from '@framework/workbench/drawer/ui/fill/constants';
import { WIDTH_MAX } from '@tencent/drawing-drawer-components/lib/constants';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_SELECT,
        preventFocus: true,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_LINE,
        content: '',
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FONT_BORDER_LINE_TEXT,
        value: i18n.t('线条类型'),
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.FONT_BORDER_WIDTH,
        options: {
            step: 0.25,
            min: 0,
            max: WIDTH_MAX,
            allowDecimal: true,
            maxLength: 5,
            toFixed: 2,
            inputStyle: {
                paddingLeft: 12,
            },
        },
        style: {
            minWidth: 118,
            maxWidth: 118,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FONT_BORDER_WIDTH_TEXT,
        value: i18n.t('线条粗细'),
        style: textStyle,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_COLOR,
        options: {
        },
        style: COLOR_STYLE,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FONT_BORDER_COLOR_TEXT,
        value: i18n.t('线条颜色'),
        style: textStyle,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_SPACE,
        content: '',
        style: {
            flex: 1,
            width: 'min-content',
            maxWidth: '16px',
            margin: '0 !important',
        },
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.FONT_BORDER_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.BUTTON,
        name: FormItemName.FONT_BORDER_GRADUAL_LINEAR_GRADIENT,
        options: {
            icon: <img src={LINEAR_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('线性'),
        style: buttonStyle,
    },
    {
        type: FormItemType.BUTTON,
        name: FormItemName.FONT_BORDER_GRADUAL_RADIAL_GRADIENT,
        options: {
            icon: <img src={RADIAL_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('射线'),
        style: buttonStyle,
    },
    {
        type: FormItemType.BUTTON,
        name: FormItemName.FONT_BORDER_GRADUAL_RECT_GRADIENT,
        options: {
            icon: <img src={RECT_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('矩形'),
        style: buttonStyle,
    },
    {
        type: FormItemType.BUTTON,
        name: FormItemName.FONT_BORDER_GRADUAL_SHAPE_GRADIENT,
        options: {
            icon: <img src={SHAPE_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('路径'),
        style: buttonStyle,
    },
    {
        type: FormItemType.ANGLE,
        name: FormItemName.FONT_BORDER_GRADUAL_ANGLE,
        options: {
            ...AngleOptions,
            maxLength: 4,
        },
        style: angleStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_GRADUAL_DIRECTION,
        content: '',
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_BORDER_GRADUAL_BAR,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.FONT_BORDER_GRADUAL_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        name: FormItemName.FONT_BORDER_GRADUAL_TYPE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('类型'),
        style: textStyle,
    },
    {
        name: FormItemName.FONT_BORDER_GRADUAL_DIRECTION_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('方向'),
        style: textStyle,
    },
    {
        name: FormItemName.FONT_BORDER_GRADUAL_ANGLE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('角度'),
        style: textStyle,
    },
];
